<template>
  <el-dialog
    v-model="visibleComputed"
    width="490px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal="true"
    @close="closeHandler"
    id="reboot_confirm_dialog"
  >
    <template #title>
      <div class="common-dialog-title f18">
        {{ $sakura.locale.overview.reboot_confirm_dialog.title }}
      </div>
    </template>

    <div class="message-content flex-layout">
      <div class="el-message-box__status el-icon-warning"></div>
      <div class="flex-item message-item left">
        {{ $sakura.locale.overview.reboot_confirm_dialog.message }}
      </div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeHandler()" size="mini">
          {{ $sakura.locale.dialog.cancel }}
        </el-button>
        <el-button @click="closeHandler(true, false)" size="mini">
          {{ $sakura.locale.dialog.no }}
        </el-button>
        <el-button type="primary" @click="closeHandler(true, true)" size="mini">
          {{ $sakura.locale.dialog.yes }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue'

const props = defineProps({
  name: String,
  visible: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:visible', 'sure'])


const visibleComputed = computed({
  get: () => props.visible,
  set: val => emit('update:visible', val)
})

function closeHandler(status, value) {
  if (status) {
    emit('sure', 'reboot', value)
  }
  emit('update:visible', false)
}
</script>


<style scoped>
  .dialog-footer button {
    height: 32px;
  }

  .message-content {
    margin: -20px 0;
    align-items: center;
    position: relative;
  }

  .message-content .message-item {
    padding-left: 36px;
  }
</style>
